<template>
    <div v-if="params.data" class="flex items-center item-avatar">
      <vs-avatar size="40px" :src="params.data.avatar || require('@/assets/images/pages/default-avatar.png')"/>
      <div class="ml-3 space-y-2">
          <span class="flex system-user-name font-medium">
            {{ params.data.name }}
          </span>
          <div class="system-user-email">
            {{ params.data.email }}
          </div>
      </div>
    </div>
</template>

<script>
export default {
}
</script>

<style scoped lang="scss">
  /deep/ .vs-avatar--con-img {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .item-avatar {
    line-height: normal !important;
  }

  .system-user-name {
    font-size: 14px;
  }

  .system-user-email {
    font-size: 12px;
    margin-top: 0 !important;
  }
</style>